import {
    HashStore,
    PulseEnvironment,
    TrafficSourceService,
    WebToMobileService,
} from '@pulse/browser-shared';
import { AnalyticsPlugin, BuiltinEvents, PulseEvent, PulseMessagePriority } from '@pulse/common';
import { AnalyticsSession, SessionService } from '../../../services';
import { SessionStartEvent } from './session-start-event';

/**
 * Fires session_start event when new analytics session gets initiated.
 */
export class SessionStartEventPlugin implements AnalyticsPlugin {
    private lockedLocal = '';
    constructor(
        private hashStore: HashStore,
        private trafficSourceService: TrafficSourceService,
        private sessionService: SessionService,
        private env: PulseEnvironment,
        private webToMobileService: WebToMobileService,
    ) {}

    init() {
        this.sessionService.session.subscribe((session) => {
            this.fireEvent(session);
        });

        const currentSession = this.sessionService.getSession();
        this.fireEvent(currentSession);
    }

    private async fireEvent(session: AnalyticsSession) {
        const webToMobileMetadataInfo = this.webToMobileService.getWebToMobileMetaInfo();

        if (this.lockedLocal === session.sessionId || webToMobileMetadataInfo?.['session_id']) {
            return;
        }

        this.lockedLocal = session.sessionId;

        if (!this.isNewSession(session)) {
            return;
        }

        const trafficSource = this.trafficSourceService.getTrafficSource();

        const e: PulseEvent<SessionStartEvent> = {
            event_type: BuiltinEvents.SESSION_START,
            data: {},
        };

        if (trafficSource?.clickId?.value) {
            e.data.mkt_click = {
                id: trafficSource.clickId.value,
                source: trafficSource.clickId.source,
            };
        }

        if (trafficSource?.landingPageURL) {
            e.data.landing_page_url = trafficSource?.landingPageURL;
        }

        if (trafficSource?.utmParams) {
            e.data.utm_params = trafficSource.utmParams;
        }

        if (session.renewedBy) {
            e.data.source = session.renewedBy;
        }
        this.env.win.dataLayer?.push({
            pulse: 'event',
            ...e,
            event_priority: PulseMessagePriority.High,
        });
    }

    private isNewSession(session: AnalyticsSession) {
        return this.hashStore.changed('session_start_event_session_id', session.sessionId);
    }
}
